import { render } from "./questionForm.vue?vue&type=template&id=550843ae&scoped=true"
import script from "./questionForm.vue?vue&type=script&lang=js"
export * from "./questionForm.vue?vue&type=script&lang=js"

import "./questionForm.vue?vue&type=style&index=0&id=550843ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-550843ae"]])

export default __exports__